import { Link } from "react-router-dom";
const CalendarioSemineSection = () => {
  return (
    <section className="py-4 bg-background">
      <div className="container mx-auto px-4">
        <div className="p-8 bg-blue-50 dark:bg-blue-950/20 border border-blue-200 dark:border-blue-800 rounded-xl max-w-4xl mx-auto text-center">
          <div className="mb-4 text-4xl">🍅 🥕 🥬 🌶️</div>
          <h2 className="text-3xl font-heading font-bold mb-3 text-blue-900 dark:text-blue-100">
            CALENDARIO DELLE SEMINE
          </h2>
          <p className="text-blue-800 dark:text-blue-200 mb-6 max-w-2xl mx-auto text-lg">
            Consulta il nostro calendario delle semine per scoprire quali ortaggi seminare mese per mese, le accortezze
            da avere per ognuno, la fase lunare corrente e tutte le informazioni per un raccolto abbondante!
          </p>
          <Link
            to="/calendario-semine"
            className="inline-block px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors font-medium"
          >
            Vai al calendario
          </Link>
        </div>
      </div>
    </section>
  );
};
export default CalendarioSemineSection;
